import { SortableTree, TreeItems } from 'dnd-kit-sortable-tree';
import {
  ItemChangedReason,
  TreeItemComponentProps,
} from 'dnd-kit-sortable-tree/dist/types';
import React from 'react';
import { BaseNode } from 'helpers/documents/types/base';

interface FolderListProps<ItemType extends BaseNode> {
  items: TreeItems<ItemType> | ItemType[];
  showNoItemsPlaceholder?: boolean;
  noItemsPlaceholder?: React.ReactNode;
  onChangeItems: (
    items: TreeItems<ItemType>,
    reason: ItemChangedReason<ItemType>,
  ) => void;
  footer: React.ReactNode;
  header: React.ReactNode;
  listItem: React.ForwardRefExoticComponent<TreeItemComponentProps<ItemType>>;
  styles?: {
    tree?: string;
    scrollWrapper?: string;
  };
}

export const FolderList = React.memo(FolderListComponent) as <
  ItemType extends BaseNode,
>(
  props: FolderListProps<ItemType>,
) => React.ReactElement;

function FolderListComponent<ItemType extends BaseNode>(
  props: FolderListProps<ItemType>,
) {
  const showNoItemsPlaceholder = props.showNoItemsPlaceholder ?? true;
  return (
    <div className={props.styles?.tree}>
      <div className={props.styles?.scrollWrapper}>
        {props.header}
        {props.items.length ? (
          <SortableTree
            items={props.items}
            onItemsChanged={(items, reason) => {
              props.onChangeItems(items, reason);
            }}
            TreeItemComponent={props.listItem}
          />
        ) : (
          showNoItemsPlaceholder && props.noItemsPlaceholder
        )}
        {props.footer}
      </div>
    </div>
  );
}
